import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from '../../../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../../../core/defaultValues';
import { ExceptionManager } from '../../../../../../../core/logManager';

import { resetALL } from '../../../../../../../.globals/redux/actions';

//STATE INITIAL
const INIT_STATE = {
    error: null,
    unit: null,
    open: false,
    loading: false,
    result: null,
};

const route = 'modules/manage/views/cameraManagementTab/components/editCameraManagementCamera/redux/slice'

export const editCameraManagementEditCamera = createAsyncThunk('cameraManagementTab/editCameraManagementCamera/editCameraManagementEditCamera', async (payload, { rejectWithValue, dispatch }) => {
    try {
        const response = await clientMutation(
            `
                mutation updateUnit (
                    $id: Int!,
                    $label: String
                ) {
                    result: updateUnit (
                        id: $id,
                        label: $label,
                    ) {
                        id
                        label
                    }
                }
            `,
            payload,
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.result
        
    } catch (exc) {
        ExceptionManager(exc, route, 'editCameraManagementEditCamera');
        return rejectWithValue(exc)
    }
});

const settingsCameraManageEditCameraRedux = createSlice({
    name: 'cameraManagementTab/editCameraManagementCamera',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE
        },
        openModalEditCameraManagementCamera(state, action) {
            return { ...state, open: action?.payload?.open, unit: action?.payload?.unit }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //editCameraManagementEditCamera
        builder.addCase(editCameraManagementEditCamera.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(editCameraManagementEditCamera.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });
        builder.addCase(editCameraManagementEditCamera.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = settingsCameraManageEditCameraRedux;

// Extract and export each action creator by name
export const { reset, openModalEditCameraManagementCamera } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;